const common = {
  close: "סגור",
  cancel: "ביטול",
  confirm: "אישור",
  save: "שמירה",
  delete: "מחיקה",
  loading: "טוען...",
  error: "שגיאה",
  success: "הצלחה",
  search: "חיפוש...",
  noResults: "לא נמצאו תוצאות",
  retry: "נסה שוב",
  back: "חזרה",
} as const;
export default common;
